import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  TextField,
  Toolbar,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SearchIcon from "@mui/icons-material/Search";
import { useNavigate } from "react-router-dom";
import SideBar from "../../dashboard admin/components/SideBar";
import api from "../../../../services/api/api";

const AdminCategories = () => {
  const [search, setSearch] = useState("");
  const [categories, setCategories] = useState([]);
  const [openDialog, setOpenDialog] = useState(false);
  const [categoryIdToDelete, setCategoryIdToDelete] = useState(null);
  const navigate = useNavigate();

  const getAuthToken = () => localStorage.getItem("token");

  useEffect(() => {
    const token = getAuthToken();
    if (token) {
      api.get("api/getAllCategoriesNews", {
        headers: { Authorization: `Bearer ${token}` },
      })
        .then((response) => setCategories(response.data))
        .catch((error) => console.error("Erro ao buscar categorias:", error));
    } else {
      console.error("Token de autenticação não encontrado.");
    }
  }, []);

  const handleSearch = (e) => setSearch(e.target.value);

  const filteredCategories = categories.filter((category) =>
    category.name.toLowerCase().includes(search.toLowerCase())
  );

  const handleDeleteCategory = () => {
    const token = getAuthToken();
    if (!token) {
      console.error("Token de autenticação não encontrado.");
      return;
    }
    api
      .delete(`api/deleteCategoryNews/${categoryIdToDelete}`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(() => {
        setCategories(categories.filter((cat) => cat._id !== categoryIdToDelete));
        setOpenDialog(false);
      })
      .catch((error) => {
        console.error("Erro ao excluir categoria:", error);
        setOpenDialog(false);
      });
  };

  const handleEditCategory = (catId) => navigate(`/admin/editcategornews/${catId}`);

  const handleConfirmDelete = (catId) => {
    setCategoryIdToDelete(catId);
    setOpenDialog(true);
  };

  const handleCancelDelete = () => setOpenDialog(false);

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", backgroundColor: "#f5f5f5" }}>
      <SideBar />
      <Box sx={{ flex: 1, p: 3 }}>
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Categories Management
        </Typography>

        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            backgroundColor: "#fff",
            borderRadius: 1,
            boxShadow: 1,
            mb: 2,
            p: 1,
          }}
        >
          <TextField
            size="small"
            variant="outlined"
            placeholder="Search categories..."
            value={search}
            onChange={handleSearch}
            InputProps={{
              startAdornment: <SearchIcon sx={{ mr: 1, color: "gray" }} />,
            }}
          />
          <Button
            variant="contained"
            startIcon={<AddIcon />}
            sx={{
              background: "linear-gradient(90deg, #1cb5e0, #000851)",
              textTransform: "none",
            }}
            href="createcategorynews"
          >
            Add Category
          </Button>
        </Toolbar>

        <TableContainer component={Paper} sx={{ borderRadius: 2, boxShadow: 3 }}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: "bold", width: "30%" }}>Name</TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "30%" }}>Description</TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "30%" }}>Creation Date</TableCell>
                <TableCell sx={{ fontWeight: "bold", width: "10%" }} align="right">
                  Actions
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredCategories.map((category) => (
                <TableRow key={category._id}>
                  <TableCell>{category.name}</TableCell>
                  <TableCell>{category.description}</TableCell>
                  <TableCell>{new Date(category.createdAt).toLocaleDateString()}</TableCell>
                  <TableCell align="right">
                    <IconButton color="primary" onClick={() => handleEditCategory(category._id)}>
                      <EditIcon />
                    </IconButton>
                    <IconButton color="error" onClick={() => handleConfirmDelete(category._id)}>
                      <DeleteIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      <Dialog open={openDialog} onClose={handleCancelDelete}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          <Typography>Are you sure you want to delete this category?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancelDelete} color="primary">
            Cancel
          </Button>
          <Button onClick={handleDeleteCategory} color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default AdminCategories;
